import React from 'react';
import PropTypes from 'prop-types';

import { css } from 'styled-components';
import { Grid, Col } from '../../common/interfaces';
import { Container, Padding, Margin } from '../../common/base';
import { SecurityWrapper, CertificateWrapper } from './Styled';

import { withTranslation } from '../../common/libs/i18n';

const HomeSecurity = ({ t }) => (
  <SecurityWrapper>
    <Margin vertical={80}>
      <Container>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
          `}
        >
          <Margin bottom={48}>
            <h2>{t('landing.security.title', 'Security is our Top Priority')}</h2>
            <p>
              {t(
                'landing.security.subtitle',
                'We partnered with CertiK, a world-class Smart Contract Auditor, to ensure our IDRT Smart Contract is secure.'
              )}
            </p>
          </Margin>
          <a
            href="https://certik.org/redirect.html?type=certificate&key=f03cd47f34550c8c92e34b49b2c31b52acd29c48633b1fe23948c0ed670b2b02"
            target="_blank"
            rel="noreferrer noopener"
          >
            <CertificateWrapper
              src="/static/images/security/certik-test.jpeg"
              alt="CertiK certificate"
            />
          </a>
        </div>
      </Container>
    </Margin>
  </SecurityWrapper>
);

HomeSecurity.propTypes = {
  t: PropTypes.func
};

export default withTranslation('common')(HomeSecurity);
